import React from "react";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Events from "./components/Events";
import About from "./components/About";
import Accommodation from "./components/Accommodation";
import Dining from "./components/Dining";
import Facilities from "./components/Facilities";
import Pricing from "./components/Pricing";
import Gallery from "./components/Gallery";
import Attractions from "./components/Attractions";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Events />
        <About />
        <Accommodation />
        <Dining />
        <Facilities />
        <Pricing />
        <Gallery />
        <Attractions />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
